const endpoints = {
  me: '/v2/members/me',
  refresh: '/v2/users/auth/refresh'
};

export default endpoints;
